<template>
  <div style="position: relative">

    <section class="expertThinkTank_center">
      <div class="logo"><img src="../../static/imgs/logo.png" alt="" /></div>
      <!-- <ul>
        <li @click="clickItem(0)" :class="tabIndexI == 0 ? 'checked' : ''">
          首页
        </li>
        <li @click="clickItem(1)" :class="tabIndexI == 1 ? 'checked' : ''">
          服务内容
        </li>
        <li @click="clickItem(2)" :class="tabIndexI == 2 ? 'checked' : ''">
          专家智库
        </li>
        <li @click="clickItem(3)" :class="tabIndexI == 3 ? 'checked' : ''">
          服务案例
        </li>
        <li @click="clickItem(4)" :class="tabIndexI == 4 ? 'checked' : ''">
          资讯中心
        </li>
        <li @click="clickItem(5)" :class="tabIndexI == 5 ? 'checked' : ''">
          关于鼎宏
        </li>
        <li @click="clickItem(6)" :class="tabIndexI == 6 ? 'checked' : ''">
          加入鼎宏
        </li>
      </ul> -->
      <el-menu :default-active="headActiveIndex" mode="horizontal" @select="clickItem" active-text-color="#0055a2">
        <el-menu-item index="1">
          <router-link to="/Home">首页</router-link>
        </el-menu-item>
        <el-submenu index="2">
          <template slot="title">
            <router-link to="/classicCases">服务内容</router-link>
          </template>
          <el-menu-item index="2-1">知识产权代理服务</el-menu-item>
          <el-menu-item index="2-2">知识产权法律服务</el-menu-item>
          <el-menu-item index="2-3">知识产权咨询服务</el-menu-item>
          <el-menu-item index="2-4">知识产权运营服务</el-menu-item>
          <el-menu-item index="2-5">知识产权信息化服务</el-menu-item>
          <el-menu-item index="2-6">互联网与科技应用服务</el-menu-item>
          <el-menu-item index="2-7">品牌运营服务</el-menu-item>
          <el-menu-item index="2-8">培训服务</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <router-link to="/expertThinkTank">专家智库</router-link>
          </template>
          <el-menu-item index="3-1">商标领域</el-menu-item>
          <el-menu-item index="3-2">地理标志领域</el-menu-item>
          <el-menu-item index="3-3">专利领域</el-menu-item>
          <el-menu-item index="3-4">著作权领域</el-menu-item>
          <el-menu-item index="3-5">互联网、信息技术领域</el-menu-item>
          <el-menu-item index="3-6">项目服务领域</el-menu-item>
          <el-menu-item index="3-7">品牌运营</el-menu-item>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">
            <router-link to="/serviceCase">服务案例</router-link>
          </template>
          <el-menu-item index="4-1">商标</el-menu-item>
          <el-menu-item index="4-2">地理标志</el-menu-item>
          <el-menu-item index="4-3">专利</el-menu-item>
          <el-menu-item index="4-4">版权</el-menu-item>
          <el-menu-item index="4-5">互联网</el-menu-item>
          <el-menu-item index="4-6">项目服务</el-menu-item>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">
            <router-link to="/information">资讯中心</router-link>
          </template>
          <el-menu-item index="5-1">行业资讯</el-menu-item>
          <el-menu-item index="5-2">鼎宏动态</el-menu-item>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title">
            <router-link to="/regardDH">关于鼎宏</router-link>
          </template>
          <el-menu-item index="6-1">鼎宏简介</el-menu-item>
          <el-menu-item index="6-2">鼎宏企业文化</el-menu-item>
          <el-menu-item index="6-3">鼎宏荣誉资质</el-menu-item>
          <el-menu-item index="6-4">鼎宏集团矩阵</el-menu-item>
        </el-submenu>
        <el-submenu index="7">
          <template slot="title">
            <router-link to="/joinDH">加入鼎宏</router-link>
          </template>
          <el-menu-item index="7-1">鼎宏人才观</el-menu-item>
          <el-menu-item index="7-2">社会招聘</el-menu-item>
        </el-submenu>

        <el-menu-item index="8">
          <router-link to="/concatUs">联系方式</router-link>
        </el-menu-item>
      </el-menu>
    </section>

    <section class="expertThinkTank_center_app">
      <div class="logo_app">
        <img class="left" src="../../static/imgs/logo.png" width="253px" height="88px" />
        <img class="right" src="../../static/imgs/cd.png"   @click="drawer = true" type="primary" />
      </div>      
    </section> 
    <el-carousel :interval="5000" arrow="never" loop :height="imgHeight" style="width:100%">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img class="bannerImg" ref="imgHeight" :src="item.src" @load="imgLoad" alt="" />
      </el-carousel-item>
    </el-carousel>
    <el-drawer
        title="我是标题"
        :visible.sync="drawer"
        :direction="direction"
        :with-header="false"
        :show-close="false">
        <el-menu :default-active="headActiveIndex" mode="horizontal" @select="clickItem" active-text-color="#0055a2">
        <el-menu-item index="1">
          <router-link to="/Home">首页</router-link>
        </el-menu-item>
        <el-menu-item index="2">
          <router-link to="/classicCases">服务内容</router-link>
        </el-menu-item>
        <el-menu-item index="3">
          <router-link to="/expertThinkTank">专家智库</router-link>
        </el-menu-item>
        <el-menu-item index="4">
          <router-link to="/serviceCase">服务案例</router-link>
        </el-menu-item>
        <el-menu-item index="5">
          <router-link to="/information">资讯中心</router-link>
        </el-menu-item>
        <el-menu-item index="6">
            <router-link to="/regardDH">关于鼎宏</router-link>
        </el-menu-item>
        <el-menu-item index="7">
            <router-link to="/joinDH">加入鼎宏</router-link>
        </el-menu-item>
        <el-menu-item index="8">
          <router-link to="/concatUs">联系方式</router-link>
        </el-menu-item>
      </el-menu>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [],
      imgHeight: "",
      headActiveIndex: "1",
      drawer:false,
      direction:'ltr'
    };
  },
  mounted() {
    // this.imgLoad()
    window.addEventListener(
      "resize",
      () => {
        this.imgHeight = this.$refs.imgHeight[0].height + "px";
        console.log(this.$refs.imgHeight[0].height + "px", "banner宽度");
        this.imgLoad();
      },
      false
    );
    // window.onresize = () => {
    //   this.imgLoad()
    // }
    this.$nextTick(() => {
      setTimeout(() => {
        this.imgList = [
          { src: require("../../static/imgs/home/banner3.jpg") },
          { src: require("../../static/imgs/home/banner2.jpg") },
          { src: require("../../static/imgs/home/banner1.jpg") },
          { src: require("../../static/imgs/home/banner4.jpg") },
          { src: require("../../static/imgs/home/banner5.jpg") },
        ];
      }, 0);
    });
  },
  // destroyed() {
  //   window.onresize = null;
  // },
  methods: {
    imgLoad() { 
      this.$nextTick(() => {
        this.imgHeight = this.$refs.imgHeight[0].height + "px";
      });
    },
    //滚动到顶部
    toTop() {
      let timer1 = setInterval(() => {
        if (document.documentElement.scrollTop <= 0) {
          clearInterval(timer1);
          return;
        }
        document.documentElement.scrollTop -= 20;
      }, 1);
    },
    clickItem(key, keyPath) {
      let index = keyPath[keyPath.length - 1];
      let group = Number(keyPath[0]);
      switch (group) {
        case 1:
          this.$router.push({ name: "Home" });
          break;
        case 2:
          this.$router.push({
            name: "classicCases",
            query: {
              positionID: index,
            },
          });
          if (group == this.tabIndexI + 1) {
            document.querySelector("#position001").scrollIntoView(true);
          }
          break;
        case 3:
          this.$router.push({
            name: "expertThinkTank",
            query: {
              positionID: index,
            },
          });
          break;
        case 4:
          this.$router.push({
            name: "serviceCase",
            query: {
              positionID: index,
            },
          });
          if (group == this.tabIndexI + 1) {
            document.querySelector("#position001").scrollIntoView(true);
          }
          break;
        case 5:
          this.$router.push({
            name: "information",
            query: {
              positionID: index,
            },
          });
          break;
        case 6:
          this.$router.push({
            name: "regardDH",
            query: {
              positionID: index,
            },
          });
          if (group == this.tabIndexI + 1) {
            document.querySelector("#position" + index).scrollIntoView(true);
          }
          break;
        case 7:
          this.$router.push({
            name: "joinDH",
            query: {
              positionID: index,
            },
          });
          break;
        case 8:
          this.$router.push({
            name: "concatUs",
            query: {
              positionID: index,
            },
          });
          break;
      }
    },
  },
  props: {
    tabIndexI: {
      type: Number,
      default: 0,
    },
  },

};


</script>

<style lang="scss" scoped>
// @import "../assets/style/index.scss";
/deep/ .el-submenu {
  margin: 0 !important;
}

/deep/ .el-submenu:hover .el-submenu__title {
  background: rgba(255, 255, 255, 0) !important;
}

/deep/ .el-submenu:hover a {
  color: #0055a2 !important;
}


/deep/ .el-menu.el-menu--horizontal {
  background: rgba(255, 255, 255, 0);
}

/deep/ .el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 2px solid #0055a2;
  // height: 74px;
  font-size: 14px;
  color: #0055a2;
  font-weight: bold;
}

/deep/ .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover {
  background: rgba(255, 255, 255, 0);
}

/deep/ .el-submenu__title {
  font-weight: bold;
}

.rightSide {
  position: fixed;
  right: 20px;
  bottom: 60px;
  z-index: 100;

  li {
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 20px;
    position: relative;

    .fixedImg {
      position: absolute;
      width: 100px;
      height: 100px;
      left: -110px;
      top: 0;
    }
  }

  .nt2 {
    display: none;
  }

  li:nth-child(2):hover .nt2 {
    display: block;
  }

  .nt3 {
    display: none;
  }

  li:nth-child(3):hover .nt3 {
    display: block;
  }

  .nt4 {
    display: none;
  }

  li:nth-child(4):hover .nt4 {
    display: block;
  }

  img {
    width: 30px;
  }

  background: white;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.288);
  padding: 20px 10px;
}

.expertThinkTank_center {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  // width: 100vw;
  z-index: 10000;
  left: 50%;
  transform: translate(-50%, 0);
  top: 0;

  ul {
    display: flex;

    li {
      color: #010101;
      font-weight: bold;

      cursor: pointer;
      // padding-bottom: 10px;
      // border-bottom: 3px solid transparent;
    }

    li:hover {
      color: #0055a2 !important;
    }

    li:first-child {
      margin: 0 !important;
    }
  }
}
//屏幕小于500PX隐藏expertThinkTank_center元素
@media screen and(max-width: 500px){
  .expertThinkTank_center {
    display: none;
  }
}

.expertThinkTank_center_app {
  .logo_app {
       width: 100vw;
       display: flex;
       justify-content: space-between;
    padding: 2.5rem 1rem;
    background-color: #FFF;
  }
  .left{
      // float: left;
      // width:15rem;
      // height: 100%;
  }
  .right{
          width: 30px;
          margin: auto 0;
          height: 30px;
  }
}

//屏幕大于500PX隐藏expertThinkTank_center_app元素
@media screen and(min-width: 500px){
  .expertThinkTank_center_app {
    display: none;
  }
}

/deep/ .el-carousel__button {
  background-color: #0055a2 !important;
  // width: 5rem;
}

.checked {
  border-bottom: 3px solid #0055a2 !important;
}

.logo {
  height: 94px;
  width: 260px;
  text-align: center;
  padding-top: 16px;
}


.bannerImg {
  width: 100vw;
  //height: 43.75rem;
}

/* @media screen and(max-width: 600px) {
  .expertThinkTank_center {
    .logo {
      display: none;
    }
  }

  .logo {
    height: 3rem;
    padding: 0.5rem 1rem;
  }

  .bannerImg {
    width: 100%;
    //height: 13rem;
  }
} */
</style>
